import { TypeInitProps, TypeRequest } from '../../../types';
import { encryptParams } from '../../../utils/index';
import { WEB_AFF_URL } from '../../../utils/urls';
export default class SubjectAPI {
  private request: any;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }
  /**
   * @param {string} subject_name
   * @param {string} deputy_name - name of the principal of subject
   * @param {string} password
   * @param {string} username
   * @param {number} deputy_identity_id
   * @param {string} base_infos - basic info
   * @param {string} detail_infos
   * @return {Promise} create result
   */
  createByUsername = (params: {
    subject_name: string;
    deputy_name: string;
    password: string;
    username: string;
    deputy_identity_id: number;
    base_infos?: string;
    detail_infos?: string;
    extra_params?: object;
  }) => {
    const { extra_params = {}, ...props } = params;
    const data = encryptParams(
      {
        ...props,
        ...extra_params,
      },
      [
        'subject_name',
        'deputy_name',
        'password',
        'username',
        'base_infos',
        'detail_infos',
      ]
    );
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.CREATE_BY_USERNAME,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} subject_name
   * @param {string} deputy_name - name of the principal of subject
   * @param {string} password
   * @param {string} mobile
   * @param {number} deputy_identity_id
   * @param {string} base_infos - basic info
   * @param {string} detail_infos
   * @return {Promise} create result
   */
  createByMobile = (params: {
    subject_name: string;
    deputy_name: string;
    password: string;
    mobile: string;
    deputy_identity_id: number;
    base_infos?: string;
    detail_infos?: string;
    extra_params?: object;
  }) => {
    const { extra_params = {}, ...props } = params;
    const data = encryptParams(
      {
        ...props,
        ...extra_params,
      },
      [
        'subject_name',
        'deputy_name',
        'password',
        'mobile',
        'base_infos',
        'detail_infos',
      ]
    );
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.CREATE_BY_MOBILE,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} subject_name
   * @param {string} deputy_name - name of the principal of subject
   * @param {string} password
   * @param {string} email
   * @param {number} deputy_identity_id
   * @param {string} base_infos - basic info
   * @param {string} detail_infos
   * @return {Promise} create result
   */
  createByEmail = (params: {
    subject_name: string;
    deputy_name: string;
    password: string;
    email: string;
    deputy_identity_id: number;
    base_infos?: string;
    detail_infos?: string;
    extra_params?: object;
  }) => {
    const { extra_params = {}, ...props } = params;
    const data = encryptParams(
      {
        ...props,
        ...extra_params,
      },
      [
        'subject_name',
        'deputy_name',
        'password',
        'email',
        'base_infos',
        'detail_infos',
      ]
    );
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.CREATE_BY_EMAIL,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @param {number} deputy_identity_id
   * @return {Promise} request result
   */
  getSubjectList = (params: {
    page?: number;
    page_size?: number;
    deputy_identity_id?: number;
    extra_params?: object;
  }) => {
    const {
      page = 1,
      page_size = 10,
      deputy_identity_id,
      extra_params = {},
    } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: `${WEB_AFF_URL.SUBJECT_LIST}${page}/`,
        method: 'GET',
        data: {
          page_size,
          deputy_identity_id,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @return {Promise} request result
   */
  getSubjectDeputyList = (params: {
    page?: number;
    page_size?: number;
    extra_params?: object;
  }) => {
    const { page = 1, page_size = 10, extra_params = {} } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: `${WEB_AFF_URL.SUBJECT_DEPUTY_LIST}${page}/`,
        method: 'GET',
        data: {
          page_size,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @return {Promise} request result
   */
  getSubjectIdentityList = (params: {
    page?: number;
    page_size?: number;
    extra_params?: object;
  }) => {
    const { page = 1, page_size = 10, extra_params = {} } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: `${WEB_AFF_URL.SUBJECT_IDENTITY_LIST}${page}/`,
        method: 'GET',
        data: {
          page_size,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} sec_user_id - encrypted uid
   * @param {number} deputy_identity_id
   * @param {string} deputy_name
   * @param {string} user_identity_id
   * @return {Promise} update result
   */
  updateDeputyInfo = (params: {
    sec_user_id: string;
    deputy_identity_id?: number;
    deputy_name?: string;
    user_identity_id: string;
    extra_params?: object;
  }) => {
    const {
      sec_user_id,
      deputy_identity_id,
      deputy_name,
      user_identity_id,
      extra_params = {},
    } = params;
    const data = encryptParams(
      {
        sec_user_id,
        deputy_identity_id,
        deputy_name,
        user_identity_id,
        ...extra_params,
      },
      ['deputy_name', 'user_identity_id']
    );
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.UPDATE_DEPUTY_INFO,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} sec_user_id - encrypted uid
   * @param {string} user_identity_id
   * @param {number} is_frozen - whether to freeze
   * @return {Promise} freeze result
   */
  freezeDeputy = (params: {
    sec_user_id: string;
    user_identity_id: string;
    is_frozen: number;
    extra_params?: object;
  }) => {
    const {
      sec_user_id,
      user_identity_id,
      is_frozen = 0,
      extra_params = {},
    } = params;
    const data = encryptParams(
      {
        sec_user_id,
        user_identity_id,
        is_frozen,
        ...extra_params,
      },
      ['sec_user_id', 'user_identity_id']
    );
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.FREEZE_DEPUTY,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} sec_user_id - encrypted uid
   * @param {string} user_identity_id
   * @return {Promise} delete result
   */
  deleteDeputy = (params: {
    sec_user_id: string;
    user_identity_id: string;
    extra_params?: object;
  }) => {
    const { sec_user_id, user_identity_id, extra_params = {} } = params;
    const data = encryptParams(
      {
        sec_user_id,
        user_identity_id,
        ...extra_params,
      },
      ['user_identity_id']
    );
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.DELETE_DEPUTY,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} sec_subject_uid - encrypted subject uid
   * @param {string} subject_name
   * @param {string} base_infos
   * @param {string} detail_infos
   * @return {Promise} update result
   */
  updateSubjectInfo = (params: {
    sec_subject_uid: string;
    subject_name?: string;
    base_infos?: string;
    detail_infos?: string;
    extra_params?: object;
  }) => {
    const {
      sec_subject_uid,
      subject_name,
      base_infos,
      detail_infos,
      extra_params = {},
    } = params;
    const data = encryptParams(
      {
        sec_subject_uid,
        subject_name,
        base_infos,
        detail_infos,
        ...extra_params,
      },
      ['sec_subject_uid', 'subject_name', 'base_infos', 'detail_infos']
    );
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.UPDATE_SUBJECT_INFO,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} sec_subject_uid - encrypted subject uid
   * @param {number} is_frozen - whether to freeze
   * @return {Promise} freeze result
   */
  freezeSubject = (params: {
    sec_subject_uid: string;
    is_frozen?: number;
    extra_params?: object;
  }) => {
    const { sec_subject_uid, is_frozen = 0, extra_params = {} } = params;
    const data = encryptParams(
      {
        sec_subject_uid,
        is_frozen,
        ...extra_params,
      },
      ['sec_subject_uid']
    );
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.FREEZE_SUBJECT,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };
}
